import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import axios from "axios";
import { initAnalytics } from './analytics';


axios.defaults.baseURL=process.env.REACT_APP_API_URL;
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
       <BrowserRouter>
       <App />
       </BrowserRouter>
 
  </React.StrictMode>
);


